import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { Products } from '../../../core/services/products.service';
import { Product, ProductStock } from '../../../shared/models/Product';

@Component({
  selector: 'app-stock-control',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, ButtonModule,
    InputNumberModule, InputTextModule, DialogModule,
    TagModule, ToastModule, TooltipModule
  ],
  providers: [MessageService],
  templateUrl: './stock-control.component.html',
  styleUrls: ['./stock-control.component.css']
})
export class StockControlComponent implements OnInit {

  products: Product[] = [];

  stockDialogVisible: boolean = false;
  selectedProduct: Product | null = null;
  tempAddValues: { [key: number]: number } = {};

  constructor(
    private productService: Products,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadProducts();
  }

  loadProducts() {
    this.productService.getAdminProducts().subscribe({
      next: (data) => {
        this.products = data;
        this.cdr.detectChanges();
      },
      error: (e) => console.error(e)
    });
  }

  openManageStock(product: Product) {
    if (!product.stockDetails || product.stockDetails.length === 0) {
      this.messageService.add({severity: 'info', summary: 'Aviso', detail: 'Este producto no tiene tallas configuradas. Edítalo en la sección Productos.'});
      return;
    }

    this.selectedProduct = product;
    this.tempAddValues = {};
    this.stockDialogVisible = true;
  }

  addStock(stockDetail: ProductStock) {
    if (!this.selectedProduct) return;

    const qtyToAdd = this.tempAddValues[stockDetail.sizeId];

    if (!qtyToAdd || qtyToAdd <= 0) {
      return;
    }

    const dto = {
      productId: this.selectedProduct.id,
      sizeId: stockDetail.sizeId,
      quantityToAdd: qtyToAdd
    };

    this.productService.addStock(dto).subscribe({
      next: () => {
        stockDetail.quantity += qtyToAdd;
        this.selectedProduct!.stock += qtyToAdd;
        this.tempAddValues[stockDetail.sizeId] = 0;
        this.messageService.add({ severity: 'success', summary: '¡Stock Agregado!', detail: `Se sumaron ${qtyToAdd} unidades a la talla ${stockDetail.sizeName}` });
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error(err);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No se pudo actualizar.' });
      }
    });
  }

  applyFilterGlobal($event: any, stringVal: string) {
    const table = document.querySelector('p-table') as any;

  }

  getStockSeverity(qty: number): 'success' | 'warn' | 'danger' {
    if (qty > 10) return 'success';
    if (qty > 0) return 'warn';
    return 'danger';
  }
}
